<template src="./index.html"></template>
<script>
import { ssoLogin,getRoleMenuIdListByUser } from '../../../api/home.js';
import configHttp from '../../../../configHttp.js';
const baseurl = configHttp.baseURL
export default {
	data() {
		return {
			userName: ''
		};
	},
	created() {
		
	},
	mounted() {},
	methods: {
		authforlogin() {
			this.getRequestParam().then(requestParam => {
				if(requestParam && requestParam['userCode']) {
					this.userName = requestParam['userCode'];
					this.ssoLogin();
				} else {
					//进入前端根页面，则跳转至后端，进行单点登录
					window.location.href = baseurl;
				}
			});
		},
		ssoLogin() {
			let params = {
				userName: this.userName
			};
			ssoLogin(params).then(res => {
				if (res.data.data.success) {
					localStorage.setItem('currentLoginUser', JSON.stringify(res.data.data.currentLoginUser));
					localStorage.setItem('sysUserSTXX', JSON.stringify(res.data.data.sysUserSTXX));
					localStorage.setItem('token', res.data.data.token);
					getRoleMenuIdListByUser().then(res1 => {
						res1.data.data.menuList.unshift({
							children: [],
							icon: 'meauicon5',
							id: '2',
							resCode: 'home',
							resName: '首页',
							checked: false
						});
						localStorage.setItem('MenuPermission', JSON.stringify(res1.data.data.menuList));
						localStorage.setItem('resources', JSON.stringify(res1.data.data.buttonList));
						var meaurouter = [];
						digui(res1.data.data.menuList);
						function digui(data) {
							data.forEach(v => {
								if (v.children) {
									if (v.resCode != '' && v.resName != '凭证导入' && v.resName != '账务查询' && v.resName != '报表中心') {
										meaurouter.push(v.resCode);
									}
									digui(v.children);
								} else {
									if (v.resCode == 'VoucherQuery') {
										meaurouter.push('VoucherDetail');
										meaurouter.push('PreviewVoucher');
										meaurouter.push('GLView');
										meaurouter.push('SubLedgerTable');
									}
									meaurouter.push(v.resCode);
								}
							});
						}
						localStorage.setItem('meaurouter', meaurouter);
						this.$router.push({
							path: '/' + meaurouter[0]
						});
					});
				} else {
					this.$message.error(res.data.data.message);
				}
			});
		},
		async getRequestParam() {   //  获取请求后面的参数
			var requestParam = new Object();
			if(location.href.indexOf('?') != -1) {
				var url = location.href.substring(location.href.indexOf('?')); //获取url中"?"符后的字串
				var str = url.substr(1);
				let strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					requestParam[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]); //获取中文参数转码<span style="font-family: Arial, Helvetica, sans-serif;">decodeURI</span>，（unescape只针对数字，中文乱码)
				}
			}
			return requestParam;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
